import PaymentAPI from "../utils/PaymentAPI";

/* eslint-disable import/no-anonymous-default-export */
export default {
    async createSession(orderDto) {
        return PaymentAPI.post("/adyen/sessions", {
            request: JSON.stringify(orderDto ?? "")
        })
    },

    async createSession2(orderRef, totalAmount) {
        return PaymentAPI.post("/adyen/sessions2", {
            orderReference: orderRef,
            totalAmount: totalAmount,
        })
    },

    async getNotifications(orderGuid){
      return PaymentAPI.get('/notification/GetAllById/' + orderGuid);
  },

};
